import { API, get } from "api";
import { ApiBooking } from "store/features/materialSpecs/ad/interfaces";
import { buildAdModel } from "./factories/ad.factory";

export const getAd = async (headers: HeadersInit, materialSpec: string) => {
    const { parsedBody } = await get<ApiBooking>(`${API.baseApiUrl}/loadcampaign`, {
        headers,
    });

    if (!parsedBody) {
        throw new Error("Could not retrieve data!");
    }

    return buildAdModel(parsedBody, materialSpec);
};
